import React from 'react'

function SkillList({content}) {
    return (
        <div className="bar">
            <div className="info">
                <span>{content}</span>
            </div>
            <div className={`progress-line ${content}`}><span></span></div>
        </div>
    )
}

export default SkillList
